import PropTypes from 'prop-types';
import { Row, Col, Button, Space, Typography } from 'antd';
import moment from 'moment';

const { Text } = Typography;
const filters = ['Today', 'This Month', 'Last Month'];

export function QuickFilters({ setDateRange, selectQfilt, setQfilt, updatefn }) {
	function setFilt(filt) {
		setQfilt(filt);
		let newDateRange;
		switch (filt) {
			case 'Today':
				newDateRange = {
					startDate: moment().startOf('day'),
					endDate: moment().endOf('day'),
				};
				setDateRange(newDateRange);
				// Auto-apply filter when quick filter is selected
				if (updatefn) {
					updatefn(false, newDateRange); // Pass the new date range
				}
				return null;
			case 'This Month':
				newDateRange = {
					startDate: moment().startOf('month'),
					endDate: moment(),
				};
				setDateRange(newDateRange);
				// Auto-apply filter when quick filter is selected
				if (updatefn) {
					updatefn(false, newDateRange); // Pass the new date range
				}
				return null;
			case 'Last Month':
				newDateRange = {
					startDate: moment().subtract(1, 'month').startOf('month'),
					endDate: moment().subtract(1, 'month').endOf('month'),
				};
				setDateRange(newDateRange);
				// Auto-apply filter when quick filter is selected
				if (updatefn) {
					updatefn(false, newDateRange); // Pass the new date range
				}
				return null;
			default:
				return null;
		}
	}
	return (
		<Row align="middle" justify="start">
			<Space>
				<Text>QFilt:</Text>
				{filters.map((item) => (
					<Col key={item}>
						<Button
							style={{ width: '100px' }}
							type={selectQfilt === item && 'primary'}
							onClick={() => setFilt(item)}
						>
							{item}
						</Button>
					</Col>
				))}
			</Space>
		</Row>
	);
}

QuickFilters.propTypes = {
	setDateRange: PropTypes.func,
	setQfilt: PropTypes.func,
	selectQfilt: PropTypes.string,
	updatefn: PropTypes.func,
};
